class Anchors {
  stateClasses = {
    active: 'anchor__item--active',
  }

  constructor($el) {
    this.$el = $el;
    this.$window = $(window);
    this.$anchorList = this.$el.find('[data-anchors="list"]');
    this.$anchorItems = this.$el.find('[data-anchors="item"]');
    this.$header = $('header');
    this.isInside = false;
    this.activeIndex = -1;
    this.init();
  }

  init = () => {
    this.buildTargets();
    this.$anchorItems.on('click', this.onAnchorClick);
    this.$window.on('scroll', this.handleScroll);
    this.$window.on('resize', this.onResize);
    this.$window.on('load', this.onResize);
    this.handleScroll();
  }

  onResize = () => {
    this.buildTargets();
    this.handleScroll();
  }

  buildTargets = () => {
    this.targets = this.$anchorItems.map((i, item) => {
      const targetId = $(item).data('href');
      const $target = $(`#${targetId}`);

      return {
        $item: $(item),
        $target,
        top: $target.length ? $target.offset().top : null,
      };
    }).get();
  }

  handleScroll = () => {
    const scrollTop = this.$window.scrollTop();
    const elTop = this.$el.offset().top;
    const elBottom = elTop + this.$el.outerHeight();

    const isInside = scrollTop >= elTop && scrollTop < elBottom;

    if (isInside !== this.isInside) {
      this.isInside = isInside;
      this.$window.trigger(isInside ? 'header:lock' : 'header:unlock');
    }

    this.updateActiveItem(scrollTop);
  }

  updateActiveItem = (scrollTop) => {



    const offset = this.$anchorList.innerHeight();
    console.log(offset);
    let newActiveIndex = -1;

    this.targets.forEach((target, index) => {
      if (target.top === null) return;

      if (scrollTop + offset + 1 >= target.top) {
        newActiveIndex = index;
      }
    });

    if (newActiveIndex === this.activeIndex) return;

    this.activeIndex = newActiveIndex;

    this.targets.forEach((target, index) => {
      target.$item.toggleClass(this.stateClasses.active, index === newActiveIndex);
    });
  }

  onAnchorClick = (e) => {
    e.preventDefault();

    const targetId = $(e.currentTarget).data('href');
    const $target = $(`#${targetId}`);
    const anchorListHeight = this.$anchorList.innerHeight();
    if (!$target.length) return;

    const targetTop = $target.offset().top - anchorListHeight;

    $('html, body').animate({
      scrollTop: targetTop,
    }, 0);
  }

  onResize = () => {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.buildTargets();
      this.handleScroll();
    }, 100);
  }
}

export default Anchors;